import { NgOptimizedImage } from '@angular/common';
import { ChangeDetectionStrategy, Component, inject } from '@angular/core';
import { FormControl, ReactiveFormsModule } from '@angular/forms';

import {
  FeatureDiscoveryStepperComponent,
  FeatureDiscoveryStepperComponentI,
} from '@core/feature-discovery-ui';
import { injectTranslate, TranslatePipe } from '@core/i18n-legacy';
import { ImportSkillsCacheService } from '@core/tellent-skills-logic';
import {
  ButtonComponent,
  CheckboxComponent,
  DialogBodyComponent,
  DialogComponentI,
  DialogFooterComponent,
  DialogRef,
  HeadingComponent,
  IconComponent,
} from '@core/user-interface-legacy';

@Component({
  selector: 'tlc-import-skills-intro-dialog',
  templateUrl: './import-skills-intro-dialog.component.html',
  styleUrl: './import-skills-intro-dialog.component.less',
  changeDetection: ChangeDetectionStrategy.OnPush,
  imports: [
    DialogBodyComponent,
    DialogFooterComponent,
    ButtonComponent,
    CheckboxComponent,
    HeadingComponent,
    IconComponent,
    ReactiveFormsModule,
    TranslatePipe,
    FeatureDiscoveryStepperComponent,
    NgOptimizedImage,
  ],
})
export class ImportSkillsIntroDialogComponent implements DialogComponentI<
  void,
  Record<string, never>
> {
  private readonly t = injectTranslate();
  private readonly cacheService = inject(ImportSkillsCacheService);
  private readonly dialogRef = inject(DialogRef);

  protected readonly dontShowAgainControl = new FormControl<boolean>(false, { nonNullable: true });

  protected readonly steps: FeatureDiscoveryStepperComponentI[] = [
    {
      heading: this.t('tlc.positions.import_skills_flow.intro.steps.upload.heading'),
      content: this.t('tlc.positions.import_skills_flow.intro.steps.upload.description'),
    },
    {
      heading: this.t('tlc.positions.import_skills_flow.intro.steps.preview.heading'),
      content: this.t('tlc.positions.import_skills_flow.intro.steps.preview.description'),
    },
    {
      heading: this.t('tlc.positions.import_skills_flow.intro.steps.apply.heading'),
      content: this.t('tlc.positions.import_skills_flow.intro.steps.apply.description'),
    },
  ];

  public setDialogData(_data: void, _triggerUpdate: boolean): void {
    //
  }

  public cancel(): void {
    this.dialogRef.close();
  }

  public continue(): void {
    if (this.dontShowAgainControl.value) {
      this.cacheService.setDontShowIntroFlag().then(() => {
        this.dialogRef.close({});
      });
      return;
    }
    this.dialogRef.close({});
  }
}
